export default {
  text: '#585858',
  primary: '#1734b5',
  secondary: '#000000',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#000000'
}
